var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4B55",
    d: "m27 59a2 2 0 0 1 -2-2v-19.23l-18.54-20.39a5.61 5.61 0 0 1 4.15-9.38h42.78a5.61 5.61 0 0 1 4.15 9.38l-18.54 20.39v11.23a2 2 0 0 1 -.75 1.56l-10 8a2 2 0 0 1 -1.25.44zm-16.39-47a1.61 1.61 0 0 0 -1.19 2.69l19.06 21a2 2 0 0 1 .52 1.31v15.84l6-4.84v-11a2 2 0 0 1 .52-1.35l19.06-21a1.61 1.61 0 0 0 -1.19-2.65z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIc);
export default __webpack_public_path__ + "static/media/filter-ic.8658f42fb165e05b84ecf63ebd42e8c6.svg";
export { ForwardRef as ReactComponent };